module.exports = __webpack_public_path__ + "static/img/暗纹.27aac62.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Economics/暗纹.png
// module id = +iNs
// module chunks = 0